import { t } from "@/i18n-js/instance";
import { DefaultFullPreview } from "../../..";

export const HeaderPaywallCustomizationLine = () => (
  <DefaultFullPreview.PreviewEntry
    label={t("paywall_checkout.future_payments.header")}
    labelWeight="semibold"
    dataTestId="checkout-form-preview-future-payments-total"
  />
);
